/* holy-shipping-protection.js · keeps the Shipping Protection line matched to the basket (2026-10-21).
   The snippet renders the truth from the server (on/off, the line's key, the variant the basket calls for).
   This file: a tap adds or removes the line; after any cart change the drawer re-renders, and if the
   toggle is on but the variant no longer matches the basket, the line is swapped. Nothing is added
   without a tap. Works in the drawer (section re-render) and on the cart page (reload). */
(function () {
  'use strict';
  var busy = false;
  function json(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  function el() { return document.querySelector('[data-holy-sp]'); }
  function rerender() {
    var drawer = document.querySelector('cart-drawer[data-holy-section="cart-drawer"]');
    var wrap = drawer && drawer.closest('[id^="shopify-section-"]');
    var onCartPage = /^\/cart\/?$/.test(location.pathname);
    if (onCartPage) { location.reload(); return Promise.resolve(); }
    if (!wrap) return Promise.resolve();
    return fetch(location.pathname + '?section_id=' + wrap.id.replace('shopify-section-', ''), { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('CartDrawer'); var cur = document.getElementById('CartDrawer');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        var fw = doc.querySelector('cart-drawer');
        if (fw && drawer) { var n = parseInt(fw.getAttribute('data-cart-count'), 10) || 0; drawer.setAttribute('data-cart-count', String(n)); drawer.classList.toggle('wt-cart--empty', n === 0); drawer.classList.toggle('holy-cart-drawer--empty', n === 0); }
      }).catch(function () {});
  }
  function add(variant) { return json('/cart/add.js', { items: [{ id: Number(variant), quantity: 1, properties: { _shipping_protection: 'basket' } }] }); }
  function remove(key) { return json('/cart/change.js', { id: key, quantity: 0 }); }
  function set(on) {
    var n = el(); if (!n || busy) return; busy = true;
    var p = on ? add(n.getAttribute('data-target-variant')) : remove(n.getAttribute('data-current-key'));
    p.catch(function () {}).then(rerender).then(function () { busy = false; });
  }
  /* After a server re-render: on, but the basket moved to another band → swap the line. */
  function sync() {
    var n = el(); if (!n || busy) return;
    if (n.getAttribute('data-on') !== 'true') return;
    var cur = n.getAttribute('data-current-variant'), target = n.getAttribute('data-target-variant');
    if (!cur || !target || cur === target) return;
    busy = true;
    remove(n.getAttribute('data-current-key')).then(function () { return add(target); }).catch(function () {}).then(rerender).then(function () { busy = false; });
  }
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.matches('[data-holy-sp-toggle]')) return;
    set(t.checked);
  });
  var drawerEl = document.getElementById('CartDrawer');
  if (drawerEl && 'MutationObserver' in window) {
    var timer = null;
    new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(sync, 150); }).observe(drawerEl, { childList: true, subtree: false });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
